import React from 'react';

const FlexRow = ({ children, ...attrs }) => (
  <div className="flex-row-v1" {...attrs}>
    {children}
  </div>
);

export default FlexRow;
